document.addEventListener('app:load', init)

function init ()
{
	const informations = document.querySelector('#informations')
	const informationsOpen = document.querySelector('#floating-buttons .floating-button-informations')
	
	if (informations)
	{
		informationsOpen.classList.add('visible')
	} else {
		return
	}
	
	const informationsId = informations.dataset.id
	const informationsClose = informations.querySelector('.close')
	
	informationsOpen.addEventListener('click', () =>
	{
		informations.classList.add('show')
	})
	
	informationsClose.addEventListener('click', () =>
	{
		informations.classList.remove('show')
		
		localStorage.setItem('informations_show', '0')
	})
	
	if (localStorage.getItem('informations_id') !== informationsId)
	{
		informations.classList.add('show')
		
		localStorage.setItem('informations_id', informationsId)
		localStorage.setItem('informations_show', '1')
	}
	
	if (localStorage.getItem('informations_show') === '1')
	{
		informations.classList.add('show')
	}
}
